import React from 'react';

import { useTranslation } from "react-i18next";

import {Link} from 'react-router-dom';
import UserActions from "./UserActions"

import logo from '../../images/sg3plus.png';
import headerWebSite1 from '../../images/bridg/header-bg-1.jpg';
import headerWebSite2 from '../../images/bridg/header-bg-2.jpg';
import headerWebSite3 from '../../images/bridg/header-bg-3.jpg';
import headerWebSite4 from '../../images/bridg/header-bg-4.jpg';

import '../../css/TopNavBar.css';
import { onGoToSG3PlusClick } from '../../common/Helpers';

function TopNavbar(props) {
    
    const { t } = useTranslation();

    const styleHeader1 = {
      backgroundImage: "url('" + headerWebSite1 + "')",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      height: "250px",
      width: "100%",
      //boxShadow: "0px 10px 5px #888888",
      //opacity: ".7",
      backgroundPosition: "50% 50%"
    }

    const styleHeader2 = {
      backgroundImage: "url('" + headerWebSite2 + "')",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      height: "250px",
      width: "100%",
      //boxShadow: "0px 10px 5px #888888",
      //opacity: ".7",
      backgroundPosition: "50% 82%"
    }

    const styleHeader3 = {
      backgroundImage: "url('" + headerWebSite3 + "')",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      height: "250px",
      width: "100%",
      //boxShadow: "0px 10px 5px #888888",
      //opacity: ".7",
      backgroundPosition: "50% 46%"
    }

    const styleHeader4 = {
      backgroundImage: "url('" + headerWebSite4 + "')",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      height: "250px",
      width: "100%",
      //boxShadow: "0px 10px 5px #888888",
      //opacity: ".7",
      backgroundPosition: "50% 59%"
    }

    const d1 = new Date();
    

    const siteTitle = props.currentAuth !== null ? props.currentAuth.clientName : "";

    const styleHeader = (d1.getSeconds() < 15) ? styleHeader1 : ((d1.getSeconds() >= 15 && d1.getSeconds() < 30) ? styleHeader2 : ((d1.getSeconds() >= 30 && d1.getSeconds() < 45)? styleHeader3 :styleHeader4));

    return (
      <div>
      <nav className="navbar top-navbar navbar-dark bg-primary navbar-fixed-top">
        <div className="navbar-header ps-5 cursor-pointer" onClick={()=> onGoToSG3PlusClick()}>
          <img width={80} src={logo} alt="Logo" />
        </div>
        <div style={{float: "left",
    position: "absolute",
    paddingLeft: "135px",
    color: "#fff",
    fontSize: "xx-large"}}>
          <div className='cursor-pointer' onClick={()=> onGoToSG3PlusClick()}>{siteTitle}</div>
        </div>
        <div className="container-flex">
          <div className="float-end pe-5">
            <div className="nav" id="collapsenav">
              { !props.currentAuth &&
                <ul className="navbar-nav m-3">
                  <li className="nav-item"><Link exact="true" to="/login">{t('data-lang-topnavbar-login')}</Link></li>  
                </ul>
              }
              { props.currentAuth &&
                 <UserActions exportAsImage={props.exportAsImage} userName={props.currentAuth.userName} logOut={props.logOut} />
              }
            </div>
          </div>
        </div>
      </nav>
      <div
        className="mb-5 text-center bg-image"
        style={styleHeader}
      />
      </div>
    )
}
export default TopNavbar